import React from "react"

import SelectProjectAccess from "core/gd-ui/select-project-access/select-project-access"
import UserIcon from "core/gd-ui/icon/user/user"
import Button, {ButtonSize} from "../../../gd-components/buttons/gd-button/gd-button-ui5-new"
import SelectAccess from "../../../gd-ui/select-access/select-access"

export default function ModalAddUserCompanyUsers(props) {

    const onAccessSelect = (userId, access) => {
        props.onAccessSelect(userId, access);
    }

    const onUserClick = (userId, e) => {
        props.onUserClick(userId, 'company', e)
    }

    const onUserAdd = (userId, access, e) => {
        props.onUserAdd(userId, access, 'company', e)
    }

    const companyUsers = _.get(props,'companyUsers', [])

    const selectedArr = props.selected.map(obj=>obj.userId)

    const listClasses = Classes('ui5-manage-list','users-with-access',{
        'multiselect': props.multiselect
    });

    return (
        <div className={listClasses}>
            {_.map(companyUsers,(cu, key)=>{
                const isSelected = selectedArr.includes(cu.user.id)

                const classes = Classes('row', {
                    selected: isSelected
                })

                let col0 = false;
                if (props.multiselect) {
                    const checkboxClasses = Classes('ui5-cb', 's-16', {
                        selected: isSelected
                    });
                    col0 = (
                        <div className="cell center">
                            <div className={checkboxClasses}/>
                        </div>
                    )
                }

                // col3
                let col3 = false;
                if (['chat','common'].includes(props.mode) && !props.projectId && !props.accessLevels) {
                    //do nothing
                } else if (!isSelected) {
                    col3 = props.showDepartments ? gd.session.departments.get(cu.departmentId).name : false;
                } else if (props.accessLevels) {
                    const selectedItem = _.find(props.selected, (o)=>o.userId === cu.user.id);
                    col3 = (
                        <div className="access-block m-r-5">
                            <div className="lbl">access:</div>
                            <SelectAccess accessLevels  = {props.accessLevels}
                                          value         = {selectedItem.access}
                                          onSelect      = {onAccessSelect.bind(this, selectedItem.userId)}/>
                        </div>
                    )
                } else {
                    const selectedItem = _.find(props.selected, (o)=>o.userId === cu.user.id);

                    let accessLevels, addButton
                    switch (props.mode) {
                        case 'task':
                            accessLevels    = [gd.const.project.access.LIMITED, gd.const.project.access.STANDARD, gd.const.project.access.FULL]
                            if (!props.multiselect) {
                                addButton   = <Button className = "m-r-10"
                                                      size      = {ButtonSize.TINY}
                                                      label     = "Add"
                                                      onClick   = {(e)=>onUserAdd(selectedItem.userId, selectedItem.access, e)}/>
                            }
                            break
                    }

                    col3 = (
                        <>
                            <div className="access-block m-r-5">
                                <div className="lbl">access:</div>
                                <SelectProjectAccess mode           = "new-user"
                                                     renderValue    = "text-12"
                                                     value          = {selectedItem.access}
                                                     accessLevels   = {accessLevels}
                                                     projectId      = {props.projectId}
                                                     userId         = {selectedItem.userId}
                                                     onSelect       = {onAccessSelect.bind(this, selectedItem.userId)}/>
                            </div>
                            {addButton}
                        </>
                    )
                }

                return (
                    <div className={classes} key={key} onClick={onUserClick.bind(this, cu.user.id)}>
                        {col0}
                        <div className="cell content">
                            <UserIcon userId={cu.user.id} size="26" className="m-r-10"/>
                            <div className="user-name">{cu.user.name}</div>
                        </div>
                        <div className="cell">{col3}</div>
                    </div>
                )
            })}
        </div>
    )
}